import { Grid, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from '@mui/material/Button';
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { generateGenomicsResearchUrl } from "../../../../helpers/generateUrl";
import {
    getProjects, getSequencing
} from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        hoveItem: {
            cursor: "pointer",
        },
        input: {
            padding: "1px",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        card: {
            height: "100%",
            padding: "20px",
        },
        cardContent: {
            textAlign: "center",
        },
        text: { color: "black" },
    })
);

interface Props {
    getProjects: any;
    projects: any;
    getSequencing: any;
    fetchRunSequencing: any;


}
const StopsPlace: React.FC<Props> = ({
    getProjects,
    projects,
    getSequencing,
    fetchRunSequencing,


}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const [runId, setRunId] = useState<any>();
    useEffect(() => {
        getProjects();
        getSequencing();

    }, [])

    const showRunFilter = (e: any) => {
        const body: any = {
            runId: runId,
        };
        const url = generateGenomicsResearchUrl(body).substring(2);
        getSequencing(url);
      };

    return (
    <form style={{ width: "100%", marginLeft: 14 }} onSubmit={showRunFilter}>
        <Grid container spacing={2} style={{ marginTop: 20 }}>
            <Grid
                container
                spacing={1}
                direction="row"
                style={{ marginTop: 10 }}
            >
                <Grid item xs={12} sm={4}>
                    <Autocomplete
                        id="RunID"
                        onChange={(event, newValue) => {
                            setRunId(newValue?.runId);
                        }}
                        options={fetchRunSequencing?.results || []}
                        blurOnSelect
                        getOptionLabel={(option: any) => {
                            return (
                                (option?.runId)
                            );
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                className="input"
                                label="Run ID"
                                variant="outlined"
                                placeholder="Search Run ID"
                                fullWidth
                            />
                        )}
                    />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={showRunFilter}

                    >
                        Filter
                    </Button>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => history.go("/dashboard/gnrelab/Sequencing")}
                    >
                        Reset
                    </Button>
                </Grid>
                {/* <Grid item xs={12} sm={4} md={2}>
                    <Button
                        variant="contained"
                        color="secondary"
                        fullWidth
                        onClick={() => history.push("/dashboard/gnrelab/Sequencing/export")}
                    >
                        Export
                    </Button>
                </Grid> */}
            </Grid>
        </Grid>
        </form>
    );
};
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsLabReducer.projects,
    fetchRunSequencing: state.GenomicsLabReducer.fetchRunSequencing,

});
export default connect(mapStateToProps, {
    getProjects,
    getSequencing,

})(StopsPlace);
